import {http} from "Services/Http/HttpClient";

export const refreshToken = async () => {
    return await http.get('refresh-token')
}

export const checkPasswordRecoveryRequest = async (token: string) => {
    return await http.get('password-recovery/detail/' + token)
}
